import type { FaireProductEntity } from "../../entity_types/product";

export const p_ks7hptwqug: FaireProductEntity = {
  token: "p_ks7hptwqug",
  type: "product",
  name: "“Love” by James Baldwin Ceramic Luxury Candle",
  brandToken: "b_83jaocy6",
  brandName: "Harlem Candle Co",
  imageUrl:
    "https://cdn.faire.com/fastly/5d0bc00564fe1e0b6aa0e0bad15e3cbc31ace227e62ddca120a286a93a275c3e.webp",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/4d28ccd153db5bdf9e26ffab8dc52cf7756e7a357855b5d672f46167cc1803c5.webp",
    "https://cdn.faire.com/fastly/167befa929b0dd9023517e75db15adf780d7f1d4a0f5d1f502523783fff15acb.webp",
    "https://cdn.faire.com/fastly/c392b75f64cace731fd64af8d69d2d030053a73d25a23b4da5215bfa31c7bad5.webp",
    "https://cdn.faire.com/fastly/71098635a8547150658aaa5f78d3f42b5d9a0acd78a0a6acc0a3e8bf85bb09cb.webp",
  ],
  priceDollars: 54,
  description:
    'This “Love” by James Baldwin Ceramic Luxury Candle features our signature “Love” scent housed in a black and gold floral ceramic vessel that portrays the iconic Harlem Candle Co. logo pattern. Once the candle finishes, the vessel becomes a beautiful home decor piece.\n\nTop Notes: Watery Green Notes, Elemi, Apple, Clove\nMiddle Notes: Rose de Mai\nBase Notes: Sandalwood\n\nInspired by his book and the motion picture If Beale Street Could Talk, the "Love" candle represents the dramatic romantic theme with both masculine and feminine accords melding beautifully together. An ethereal, fresh opening of crisp apple and watery green notes evolves with an unexpected nuance of aromatic elemi and spicy clove.\n\nThe sensual heart of lush rose celebrates Baldwin’s deep affection for his garden in Saint Paul de Vence, while a base of smoky sandalwood brings warmth and depth to this enigmatic and highly personal blend.',
  tags: [],
  msrpDollars: 102,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:52:10.545Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
